var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlogs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7587 2.77002H25.1322C26.9435 2.77002 28.4111 4.25008 28.4111 6.07664V10.4871C28.4111 12.3137 26.9435 13.7937 25.1322 13.7937H20.7587C18.9474 13.7937 17.4797 12.3137 17.4797 10.4871V6.07664C17.4797 4.25008 18.9474 2.77002 20.7587 2.77002Z",
    fill: "#200E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7587 2.77002H25.1322C26.9435 2.77002 28.4111 4.25008 28.4111 6.07664V10.4871C28.4111 12.3137 26.9435 13.7937 25.1322 13.7937H20.7587C18.9474 13.7937 17.4797 12.3137 17.4797 10.4871V6.07664C17.4797 4.25008 18.9474 2.77002 20.7587 2.77002Z",
    fill: "url(#paint0_linear_946_4577)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85705 2.76953H10.2306C12.0419 2.76953 13.5095 4.24959 13.5095 6.07615V10.4866C13.5095 12.3132 12.0419 13.7932 10.2306 13.7932H5.85705C4.04579 13.7932 2.57812 12.3132 2.57812 10.4866V6.07615C2.57812 4.24959 4.04579 2.76953 5.85705 2.76953ZM5.85705 17.5788H10.2306C12.0419 17.5788 13.5095 19.0589 13.5095 20.8855V25.2959C13.5095 27.1213 12.0419 28.6026 10.2306 28.6026H5.85705C4.04579 28.6026 2.57812 27.1213 2.57812 25.2959V20.8855C2.57812 19.0589 4.04579 17.5788 5.85705 17.5788ZM25.1296 17.5788H20.7561C18.9448 17.5788 17.4771 19.0589 17.4771 20.8855V25.2959C17.4771 27.1213 18.9448 28.6026 20.7561 28.6026H25.1296C26.9409 28.6026 28.4085 27.1213 28.4085 25.2959V20.8855C28.4085 19.0589 26.9409 17.5788 25.1296 17.5788Z",
    fill: "#200E32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85705 2.76953H10.2306C12.0419 2.76953 13.5095 4.24959 13.5095 6.07615V10.4866C13.5095 12.3132 12.0419 13.7932 10.2306 13.7932H5.85705C4.04579 13.7932 2.57812 12.3132 2.57812 10.4866V6.07615C2.57812 4.24959 4.04579 2.76953 5.85705 2.76953ZM5.85705 17.5788H10.2306C12.0419 17.5788 13.5095 19.0589 13.5095 20.8855V25.2959C13.5095 27.1213 12.0419 28.6026 10.2306 28.6026H5.85705C4.04579 28.6026 2.57812 27.1213 2.57812 25.2959V20.8855C2.57812 19.0589 4.04579 17.5788 5.85705 17.5788ZM25.1296 17.5788H20.7561C18.9448 17.5788 17.4771 19.0589 17.4771 20.8855V25.2959C17.4771 27.1213 18.9448 28.6026 20.7561 28.6026H25.1296C26.9409 28.6026 28.4085 27.1213 28.4085 25.2959V20.8855C28.4085 19.0589 26.9409 17.5788 25.1296 17.5788Z",
    fill: "url(#paint1_linear_946_4577)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_946_4577",
    x1: 22.9454,
    y1: 2.77002,
    x2: 22.9454,
    y2: 13.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_946_4577",
    x1: 15.4933,
    y1: 2.76953,
    x2: 15.4933,
    y2: 28.6026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogs);
export default __webpack_public_path__ + "static/media/blogs.8762eb534758c054171d9355dbe73165.svg";
export { ForwardRef as ReactComponent };